import {
  tpEvent,
  openWeb,
  tpDuration,
  loadTrace,
  tpDurationLoad,
  closeWeb,
  tpFlow,
  errorPath,
  getPath,
  tpEventAuto
} from './index'

/**---------------------埋点需求----------- */
export function loadTracehash(props) {
  try {
    let start = new Date().getTime()

    // 刷新页面/打开新窗口/登录等操作
    window.addEventListener('load', function (e) {
      // 启动应用
      setTimeout(() => {
        openWeb({ ...props, start })
      },1000)

      submit()
    });

    // 路由切换进行埋点
    window.addEventListener('hashchange', function (e) {
      submit()
    });

    function submit() {
      start = new Date().getTime()
      const path = getPath()
      if (!errorPath(path)) {
        return false
      }
      const oldTrace = sessionStorage.getItem('oldTrace')

      // 先执行上个页面的停留埋点
      if (oldTrace) {
        tpDuration({ ...props, start })
      }

      // 执行路由埋点
      loadTrace({ ...props, start })

      // 执行应用停留
      setTimeout(() => {
        tpDurationLoad({ ...props, start })
      }, 1000)
    }

    window.addEventListener('unload', function (e) {
      // 关闭应用
      setTimeout(() => {
        openWeb({ ...props, start })
      },1000)
    });

    // 点击事件埋点
    tpEvent({ ...props, start })

    // 流程时长埋点
    tpFlow({ ...props, start })

    // 自定义事件埋点
    tpEventAuto({ ...props, start })

  } catch (err) {
    console.log(err, '埋点错误')
  }
}


// WEBPACK FOOTER //
// ./src/tf-traceService/hash.js